<template>
  <el-card>
    <template #header>
      <content-header/>
    </template>
    <el-row type="flex" justify="left">
      <lz-form
        ref="form"
        :get-data="getData"
        :submit="onSubmit"
        :form.sync="form"
        :errors.sync="errors"
        :edit-mode="editMode"
      >
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="基础配置" name="first">
            <el-form-item label="自提地址" required prop="global_basic_config.pickUpAddress">
              <el-input v-model="form.global_basic_config.pickUpAddress"/>
            </el-form-item>
            <el-form-item label="积分金额比率" required prop="global_basic_config.integralRate">
              <el-input v-model="form.global_basic_config.integralRate">
                <template slot="append">:1</template>
              </el-input>
              比如 6:1,即6个积分=1元
            </el-form-item>
            <el-form-item label="推荐图/安置图查阅">
            </el-form-item>
            <el-form-item prop="weeks" label="每月">
              <el-checkbox-group size="small" border="true" v-model="form.days">
                <el-checkbox v-for="day in dayList" style="width:30px" :label="day.lable" :key="day.value" value="day.lable">{{day.value}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item prop="weeks" label="每周">
              <el-checkbox-group size="small" border="true" v-model="form.weeks">
                <el-checkbox v-for="week in weekList" style="width:30px" :label="week.lable" :key="week.value" value="week.lable">{{week.value}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item prop="weeks" label="时间段">
              <el-time-picker v-model="form.being_time" placeholder="任意时间点"> </el-time-picker>
              <el-time-picker v-model="form.end_time" placeholder="任意时间点"></el-time-picker>
            </el-form-item>
          </el-tab-pane>

          <el-tab-pane label="微信分享配置" name="second">
            <el-form-item label="分享标题" required prop="wx_share.title">
              <el-input v-model="form.wx_share.title"/>
            </el-form-item>
            <el-form-item label="分享描述" required prop="wx_share.description">
              <el-input v-model="form.wx_share.description"/>
            </el-form-item>
            <el-form-item label="分享logo" prop="wx_share.pic">
              <file-picker v-model="form.wx_share.pic" ext="jpg,gif,png,jpeg" />
              建议尺寸：80*80 ，大小不要超过30k
            </el-form-item>
          </el-tab-pane>

          <el-tab-pane label="微信授权配置" name="third">
            <el-form-item label="AppId" required prop="wx_account.appId">
              <el-input v-model="form.wx_account.appId"/>
            </el-form-item>
            <el-form-item label="AppSecret" required prop="wx_account.appSecret">
              <el-input v-model="form.wx_account.appSecret"/>
            </el-form-item>
          </el-tab-pane>

          <el-tab-pane label="阿里大于短信配置" name="fourth">
            <el-form-item label="accessKeyId" required prop="sms_account.apiKey">
              <el-input v-model="form.sms_account.apiKey"/>
            </el-form-item>
            <el-form-item label="accessKeySecret" required prop="sms_account.apiSecret">
              <el-input v-model="form.sms_account.apiSecret"/>
            </el-form-item>
            <el-form-item label="短信签名" required prop="sms_account.channelId">
              <el-input v-model="form.sms_account.channelId"/>
            </el-form-item>
          </el-tab-pane>

          <el-tab-pane label="阿里云身份实名认证配置" name="sixth">
            <el-form-item label="AppCode" required prop="id_card_check_config.appCode">
              <el-input v-model="form.id_card_check_config.appCode"/>
            </el-form-item>
            <el-form-item label="接口地址" required prop="id_card_check_config.url">
              <el-input v-model="form.id_card_check_config.url"/>
            </el-form-item>
          </el-tab-pane>
        </el-tabs>
      </lz-form>
    </el-row>
  </el-card>
</template>

<script>
import LzForm from '@c/LzForm'
import {
  editBaseConfig,
  updateBaseConfig,
} from '@/api/base-configs'
import FormHelper from '@c/LzForm/FormHelper'
import FilePicker from '@c/FilePicker'
import { getFirstError, getMessage } from '@/libs/utils'

export default {
  name: 'Form',
  components: {
      LzForm,
      FilePicker
  },
  mixins: [
    FormHelper,
  ],
  data() {
    return {
        form: {
            auth_code_prefix: '',
            free_freight_config: '',
            fund_share: '',
            rebate_invite: '',
            sms_account: '',
            wx_account: '',
            wx_share: '',
            repurchase_task_num: '',
            days: [],
            weeks: [],
            being_time: '',
            end_time: '',
            id_card_check_config: '',
            global_basic_config: '',
            repeat_sale_upgrade_config: '',
        },
        activeName: 'first',
        weekList: [
            {value: '周一', 'lable': 'MONDAY'},
            {value: '周二', 'lable': 'TUESDAY'},
            {value: '周三', 'lable': 'WEDNESDAY'},
            {value: '周四', 'lable': 'THURSDAY'},
            {value: '周五', 'lable': 'FRIDAY'},
            {value: '周六', 'lable': 'SATURDAY'},
            {value: '周日', 'lable': 'SUNDAY'},
        ],
        dayList: [
            {value: '1号', 'lable': '1'},
            {value: '2号', 'lable': '2'},
            {value: '3号', 'lable': '3'},
            {value: '4号', 'lable': '4'},
            {value: '5号', 'lable': '5'},
            {value: '6号', 'lable': '6'},
            {value: '7号', 'lable': '7'},
            {value: '8号', 'lable': '8'},
            {value: '9号', 'lable': '9'},
            {value: '10号', 'lable': '10'},
            {value: '11号', 'lable': '11'},
            {value: '12号', 'lable': '12'},
            {value: '13号', 'lable': '13'},
            {value: '14号', 'lable': '14'},
            {value: '15号', 'lable': '15'},
            {value: '16号', 'lable': '16'},
            {value: '17号', 'lable': '17'},
            {value: '18号', 'lable': '18'},
            {value: '19号', 'lable': '19'},
            {value: '20号', 'lable': '20'},
            {value: '21号', 'lable': '21'},
            {value: '22号', 'lable': '22'},
            {value: '23号', 'lable': '23'},
            {value: '24号', 'lable': '24'},
            {value: '25号', 'lable': '25'},
            {value: '26号', 'lable': '26'},
            {value: '27号', 'lable': '27'},
            {value: '28号', 'lable': '28'},
            {value: '29号', 'lable': '29'},
            {value: '30号', 'lable': '30'},
            {value: '31号', 'lable': '31'},
        ],
        errors: {},
    }
  },
  methods: {
      async getData() {
          let data
          ({data} = await editBaseConfig(1))
          this.fillForm(data)
      },
      async onSubmit() {
          try {
              await updateBaseConfig(1, this.form);
              this.$message.success('修改成功');
          } catch (e) {
              console.log(e);
              const res = e.response
              const err = getFirstError(res)
              err && this.$message.error(err)
          }
      },
      handleClick() {
      }
  },
}
</script>

<style scoped lang="scss">
</style>
